export default defineNuxtPlugin(async () => {
    const push = usePushNotifications();
    const authStore = useAuthStore();
    const { $auth } = useNuxtApp();

    await push.initPushNotifications();

    watch(
        () => authStore.user?.uid || $auth.currentUser?.uid || '',
        async(userId) => {
            if (!userId) {
                return;
            }

            await push.initPushNotifications();
            if (push.permission.value === 'granted') {
                await push.syncPushToken();
            }
        },
        { immediate: true },
    );
});
